var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"8qfeDGslSLugYivVNkPEs"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import * as Sentry from '@sentry/nextjs';
import { replayIntegration } from '@sentry/replay';
import { BrowserTracing } from '@sentry/tracing';

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://b6efe052560c2241bfa4cb16ae16b6a5@o4509270402400256.ingest.de.sentry.io/4509270407446608',
    sendDefaultPii: true,
    tags: { 'app.runtime': 'client' },
    tracesSampleRate: 0.1, // Adjust this value (0.0 to 1.0)
    environment: 'shop', // Or 'admin' if this is your admin app
    integrations: [
      replayIntegration({ maskAllText: false, blockAllMedia: false }),
      new BrowserTracing({
        routingInstrumentation: Sentry.nextjsRouterInstrumentation,
      }),
    ],
    replaysSessionSampleRate: 0.0,
    replaysOnErrorSampleRate: 1.0,
  });
}
